import { OfficeOfferPriceType } from '@enums/officeOfferPriceType';
import { PriceTypeMode } from '@enums/priceTypeMode';
import type { OfficeOffer as SelectionItemOfficeOffer } from '@models/groups/selectionItem';
import { trans } from '@tools/translation';

export const getOfferPriceTypeLabel = (offer: SelectionItemOfficeOffer, mode: PriceTypeMode = PriceTypeMode.SHORT): string => {
  switch (offer.price_type) {
    case OfficeOfferPriceType.RENT_MONTHLY:
      return trans(`price.monthly.${mode}`);
    case OfficeOfferPriceType.RENT_WORKSTATION:
      return trans(`price.workstation.${mode}`);
    case OfficeOfferPriceType.RENT_SURFACE:
      return trans(`price.surface.${mode}`);
    default:
      return '';
  }
};
